const PlatformDetailPage = () => {
    return (
        <div>
            Uclusion is opinionated and believes the only reasonable task data structure is like this:
            Job &gt; Tasks &gt; Grouped tasks. In a job you can have a name and description and attributes like assignee.
            Then tasks are comments that can be resolved, put in progress, and grouped or ungrouped.
            <br /><br />
            The list of work to be done for a job should be visible from main visualization page but it should also
            have its own page when you click on a job. Of the platform tools Monday comes closest to this by
            allowing tasks to recursively contain tasks.
            <br /><br />
            However what Monday did is not the same at all as you cannot see and scroll through all of the work to be 
            done for a job. Inside a Monday task you will just see a list of child task names. So although these
            platform DIY tools give their users a lot of power to customize, you cannot customize your way out of the
            basic structure of the tool.
        </div>
    );
};

export default PlatformDetailPage;